import { render, staticRenderFns } from "./ClientExpertise.vue?vue&type=template&id=29800411&"
import script from "./ClientExpertise.vue?vue&type=script&lang=js&"
export * from "./ClientExpertise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports